export default "__VITE_ASSET__BSFH5Ey4__"